module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "OKXLogo.c4036e07.png";